import { render } from "./RatingComment.vue?vue&type=template&id=7b1b91b8"
import script from "./RatingComment.vue?vue&type=script&lang=js"
export * from "./RatingComment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__